// extracted by mini-css-extract-plugin
module.exports = {"loginPage":"logout_loginPage__HiYjf","brand-welcome":"logout_brand-welcome__3X45L","brand-description":"logout_brand-description__GbW9B","loginForm":"logout_loginForm__2oUCf"};